export { isExternalLink } from './is-external-link';
